import { FC } from "react";

import Eth721ImageCard from "@/features/post/components/postCard/Eth721ImageCard";
import NFTImageCard from "@/features/post/components/postCard/NFTImageCard";
import NormalImageCard from "@/features/post/components/postCard/NormalImageCard";
import { ImageCardProps } from "@/features/post/components/postCard/type";
import { PostTypeEnum } from "@/generated/generated-hooks";

/**
 * @purpose serve as middle layer to render ImageCard based on postType
 * @return conditionally rendered %ImageCard Component
 */
export const PostCard: FC<ImageCardProps> = ({ post }) => {
  switch (post.postType) {
    case PostTypeEnum.Nft:
      return <NFTImageCard post={post} />;
    case PostTypeEnum.Eth721:
      return <Eth721ImageCard post={post} />;
  }

  return <NormalImageCard post={post} />;
};
